import BaseTrack from "./basetracks";
import {fromTimeToPixel, fromPixelToTime} from "../../../../../utils/timelineutils.js"

import {getHeaderZFile} from "../zutility/zfile.js"
import { V2_RoundedTimeCode } from "../../../../../utils/timecodev2.js";
import { directDownloadJson } from "../../../../../utils/download.js";
import { directDownloadBinary } from "../../../../../utils/download.js";
import colorBrewer from "react-syntax-highlighter/dist/esm/styles/hljs/color-brewer.js";
class CPTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id,parent)
    {

        
        super (type, datas, file1, file2, channel, id, parent);

        this.videoinfos = datas;

        this.defaultHeight = 96;
        this.minHeight = 80;
        this.maxHeight = 140;

        this.ontopmost = false;
        this.ontop = false;
        this.onbottom = true;
        this.onbottommost = false;

        this.reentrance = false;

        this.height = this.defaultHeight;
        this.minimisable = true;
        this.minimisedHeight = 24;

        //this.headerZ = getHeaderZFile(this.datas);
        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-cptrack-backcolor');      
        // récuperation des datas cp

 
        //var PosCP = this.headerZ.headerSize + this.headerZ.audioDataSize;



        this.downloadFileJsonDone = this.downloadFileJsonDone.bind(this);
        this.downloadFileJpegsDone = this.downloadFileJpegsDone.bind(this)

        this.listCP = [];
        this.listCPDraw = [];

        this.listCPToSave = null;

        
        
        directDownloadBinary (this.file2, this.downloadFileJpegsDone, this.id.toString());
        directDownloadJson (this.file1, this.downloadFileJsonDone, this.id.toString());
        /*
        typedef struct
        {
            int width;
            int height;
            float time;
            LONG frame;
        
        } ENTETESHOT;
         
        const dataView = new DataView(this.datas.buffer);
        

        for (var cp = 0; cp < this.headerZ.nbCP; cp++)
        {
            this.cpwidth = dataView.getInt32(PosCP, true);
            this.cpheight = dataView.getInt32(PosCP+4, true);
            var time = dataView.getFloat32(PosCP+8,true);
            var frame = dataView.getInt32(PosCP+12,true);

            this.listCP.push(
                {
                    position: PosCP + 16,
                    time: time,

                }
            )
            PosCP  = PosCP + 16 + 3 * (this.cpwidth * this.cpheight);
            
        }

        */


   
    }

    getCPList()
    {
        return this.listCP;
    }

    setNewDatas(datas, id, extendeddatas)
    {
        this.listCP = [];
        this.id=id;
        this.file2 = extendeddatas;
        this.file1 = datas;
        this.listCPDraw = [];
        directDownloadBinary (this.file2, this.downloadFileJpegsDone, this.id.toString());
        directDownloadJson (this.file1, this.downloadFileJsonDone, this.id.toString());
    }

    base64ToBlob(base64) {
        const parts = base64.split(',');
        const mime = parts[0].match(/:(.*?);/)[1];
        const binary = atob(parts[1]);
        const len = binary.length;
        const u8arr = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
            u8arr[i] = binary.charCodeAt(i);
        }
        return new Blob([u8arr], { type: mime });
    }


    async createAllJpeg()
    {
        this.jpegs = [];

        if (this.idfile1 === "0") return;
        if (this.idfile2 !== this.idfile1) return;

        const promises = this.listCP.map((cp, ind) => {
            if (!("off" in cp)) cp.off = false;

            let blob;

            if (cp.base64 && cp.base64 !== "")
            {
                blob = this.base64ToBlob(cp.base64);
            }
            else
            {
                blob = new Blob(
                    [this.datas.subarray(cp.offset, cp.offset + cp.size)],
                    { type: 'image/jpeg' }
                );
            }

            return createImageBitmap(blob).then(img => {
                this.jpegs[ind] = img;
            });
        });

        await Promise.all(promises); //  tout est prêt ici
    }

    checkCP(time,posy)
    {

        var ret = null;
        

        for (var i=0; i < this.listCPDraw.length; i++)
        {
            

            

            if ((time >= this.listCPDraw[i].starttime ) && (time <= this.listCPDraw[i].endtime))
                if ((posy >= this.listCPDraw[i].y ) && (posy <= this.listCPDraw[i].yf))
                {
                    const ind = this.listCPDraw[i].ind;
                    ret = {ind: ind, off: this.listCP[ind].off};
                    break;
                }
        }
        return ret;

    }

    downloadFileJpegsDone(blob, infos, file)
    {
        
        this.idfile2 = infos;
        this.datas = blob;
        this.createAllJpeg();
        
    }

    downloadFileJsonDone(blob, infos, file)
    {
        
        this.listCP = blob.list;
        this.idfile1 = infos;

        if (this.parent.props.onCpListLoaded)
            this.parent.props.onCpListLoaded(this.listCP);

        this.roundAllTimeCode();
        this.createAllJpeg();
        

    }


    isFixedHeight()
    {
        return false;
    }



    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    
    drawImageToCanvas(context, xpos, baseline, ind ,grayed=true) 
    {

            
            //if (this.reentrance) return;
            this.reentrance = true;
            // Get the canvas and its context
        
            // Draw the image to the canvas

            
            var finalHeight = this.height - 4 - 12;
            var finalWidth = (finalHeight/60) * 96;

            context.lineWidth = 2;
            context.beginPath();
            context.moveTo(xpos+4 ,baseline+4);
            context.lineTo(xpos+4 + finalWidth, this.baseline+4);
            context.lineTo(xpos+4 + finalWidth, this.baseline+4 + finalHeight);
            context.lineTo(xpos+4, baseline+4 + finalHeight);
            context.lineTo(xpos+4 ,baseline+4);
            context.stroke();
            try
            {
                context.save();
                if (grayed) context.filter ="grayscale(100%)  brightness(70%)";
                context.drawImage(this.jpegs[ind], xpos+4, baseline+4, 
                    finalWidth,finalHeight);

                context.restore();
                this.reentrance = false;
                //context.filter ="none";
            }
            catch(e)
            {
                //alert (e)
            }
            
            return finalWidth;

        
    }

    roundAllTimeCode()
    {
        this.listCP.forEach( cp=>{
            cp.time = V2_RoundedTimeCode(cp.time)
        })
    }

    redrawbackgroundLevel1(context, width, currentTime, sTimeCode, starttime, duration,fullheight, yStart)
    {


        
        if (this.idfile1 === "0") return;
        if (this.idfile2 !== this.idfile1) return;
        if (width <=0) return;
        super.redrawForeGround(context,width);


        
        this.listCPDraw = [];


        var startdrawtime = Math.floor(starttime) -1;
        if (startdrawtime< 0) startdrawtime = 0;
        var enddrawtime = startdrawtime + duration+2;

        
        context.textBaseline = 'bottom';
        context.font = "9px courier new";
        context.fillStyle="Green";

        var cont = true;
        var ind = 0;
        while (cont)
        {
            if (ind >= this.listCP.length)
                cont = false;
            else
            {
                if (this.listCP[ind].time < startdrawtime)
                    cont = true;
                else
                {
                    if (this.listCP[ind].time> enddrawtime)
                        cont= false;
                    else
                    {

                        // on dessine la zone avant et après
                        if ((this.parent.paramsst) && (this.parent.props.timelineparams) && (this.parent.props.timelineparams.displayCpArea))                        
                        {
                            
                            var xpos0 = fromTimeToPixel(this.listCP[ind].time - this.parent.paramsst.beforecp, width, starttime, duration);
                            var xpos1 = fromTimeToPixel(this.listCP[ind].time + this.parent.paramsst.aftercp, width, starttime, duration);

                            context.fillStyle =  "rgba(0, 128, 0, 0.18)";
                            context.fillRect (xpos0,yStart, xpos1-xpos0, fullheight);
                        }

                        
                        var xpos = fromTimeToPixel(this.listCP[ind].time, width, starttime, duration);


                        //console.log("Dessin cp", this.listCP[ind]);


                        context.strokeStyle ="#00A000";
                        context.lineWidth = 3;
                        context.beginPath();
                        context.moveTo(xpos,yStart);
                        context.lineTo(xpos,fullheight);
                        context.stroke();
                        
                        context.strokeStyle ="White";
                        context.fillStyle ="White";

                        var stimecode =  this.parent.getTimeCodeString(this.listCP[ind].time);
                        context.fillText(stimecode,xpos+2 , this.baseline + this.height);            
                        
                        
                        const cpwidth = this.drawImageToCanvas(context, xpos, this.baseline, ind, this.listCP[ind].off); 

                        const onecp = {
                            ind: ind,
                            starttime: this.listCP[ind].time,
                            endtime : this.listCP[ind].time + fromPixelToTime(cpwidth,width,0,duration),
                            y: this.baseline + 4,
                            yf: this.baseline + this.height,
                        }
                        this.listCPDraw.push(onecp);

                    }
                }
            }
            ind++;
        }

    }

    setNewJsonCPList(cplist)
    {
        this.listCP = cplist;
        this.listCPToSave = 
        {
            list: this.listCP,
            viid: this.videoinfos.viid,
        }
      
        this.listCPToSave = JSON.stringify(this.listCPToSave);
        this.createAllJpeg();

    }

    setNewOffValue (ret)
    {
        this.listCP[ret.ind].off = !this.listCP[ret.ind].off;
        this.listCPToSave = 
        {
            list: this.listCP,
            viid: this.videoinfos.viid,
        }
      
        this.listCPToSave = JSON.stringify(this.listCPToSave);
    }
   
}

export default CPTrack;